import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getTransactionAnalytics } from "../Redux/Action/order.action";

const TransactionCard = ({ filter }) => {
    const dispatch = useDispatch();
    const { transactionAnalytics } = useSelector((state) => state.orderReducer)
    useEffect(() => {
        dispatch(getTransactionAnalytics(filter));
    }, [filter])
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-5">
            <div className="rounded-[10px] border border-color bg-sidebar">
                <div className="p-4 card-body">
                    <div className="flex gap-4 flex-wrap items-center">
                        <div className="w-[50px] border bg-[#F7F4FD] border-[#8041F580] text-[#8041F5] h-[50px] rounded-[6px] flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-8">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" />
                            </svg>
                        </div>
                        <div>
                            <span className="text-sm font-medium block">All Order</span>
                            <span className="text-[18px] font-bold block">{transactionAnalytics?.data?.allOrders}</span>
                        </div>
                    </div>
                </div>
                <div className="px-4 py-2 card-footer flex items-center justify-between flex-wrap border-t border-color">
                    <span className={`${transactionAnalytics?.data?.totalOrderpercentage >= 0 ? 'success-text' : 'error-text'} inline-flex font-bold items-center gap-1.5`}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="size-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18" />
                        </svg>
                        {`${Math.abs(transactionAnalytics?.data?.totalOrderpercentage)}%`}
                    </span>
                    <p className="info-text text-sm font-medium">{`From The ${filter}`}</p>
                </div>
            </div>
            <div className="rounded-[10px] border border-color bg-sidebar">
                <div className="p-4 card-body">
                    <div className="flex gap-4 flex-wrap items-center">
                        <div className="w-[50px] border bg-[#F4FDF5] border-[#23882380] text-[#238823] h-[50px] rounded-[6px] flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-8">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            </svg>

                        </div>
                        <div>
                            <span className="text-sm font-medium block">completed</span>
                            <span className="text-[18px] font-bold block">{transactionAnalytics?.data?.complete}</span>
                        </div>
                    </div>
                </div>
                <div className="px-4 py-2 card-footer flex items-center justify-between flex-wrap border-t border-color">
                    <span className={`${transactionAnalytics?.data?.completepercentage >= 0 ? 'success-text' : 'error-text'} inline-flex font-bold items-center gap-1.5`}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="size-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18" />
                        </svg>
                        {`${Math.abs(transactionAnalytics?.data?.completepercentage)}%`}
                    </span>
                    <p className="info-text text-sm font-medium">{`From The ${filter}`}</p>
                </div>
            </div>
            <div className="rounded-[10px] border border-color bg-sidebar">
                <div className="p-4 card-body">
                    <div className="flex gap-4 flex-wrap items-center">
                        <div className="w-[50px] border bg-[#FFFAF5] border-[#FF851480] text-[#FF8514] h-[50px] rounded-[6px] flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-8">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z" />
                            </svg>

                        </div>
                        <div>
                            <span className="text-sm font-medium block">Order Pending</span>
                            <span className="text-[18px] font-bold block">{transactionAnalytics?.data?.pending}</span>
                        </div>
                    </div>
                </div>
                <div className="px-4 py-2 card-footer flex items-center justify-between flex-wrap border-t border-color">
                    <span className={`${transactionAnalytics?.data?.pendingpercentage >= 0 ? 'success-text' : 'error-text'} inline-flex font-bold items-center gap-1.5`}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="size-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18" />
                        </svg>
                        {`${Math.abs(transactionAnalytics?.data?.pendingpercentage)}%`}
                    </span>
                    <p className="info-text text-sm font-medium">{`From The ${filter}`}</p>
                </div>
            </div>
        </div>
    )
}

export default TransactionCard